module.exports = __webpack_public_path__ + "static/media/First Light ZTG 0591-Edit_720.6fd2b67d.jpeg";